/*
 * Copyright (c) 2020 Pantacor Ltd.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the 'Software'), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Done, Warning } from '@material-ui/icons'
import Loading from '../../atoms/Loading/Loading'
import { CURRENT_STEP_NOTIFICATIONS } from '../../../lib/const'

export default function NotificationIcon ({ classes, expanded, status }) {
  return (
    <Grid item>
      {!expanded &&
        <React.Fragment>
          {status === CURRENT_STEP_NOTIFICATIONS.LOADING &&
            <Loading
              divClassName={`${classes.deviceHeaderLoadingWrapper}`}
              imgClassName={`${classes.deviceHeaderLoading}`} />}
          {status === CURRENT_STEP_NOTIFICATIONS.SUCCESS &&
            <Done fontSize='small' className={`${classes.deviceSuccessNotification}`} />}
          {status === CURRENT_STEP_NOTIFICATIONS.WARNING &&
            <Warning fontSize='small' className={`${classes.deviceWarningNotification}`} />}
        </React.Fragment>
      }
    </Grid>
  )
}
